@if (url && !failed) {
  <img class="person-avatar-img" [src]="url" [style.width.px]="diameter" [style.height.px]="diameter" loading="lazy" alt="" (error)="failed = true" />
} @else {
  <mat-icon class="person-avatar-icon" [style.font-size.px]="diameter" [style.width.px]="diameter" [style.height.px]="diameter">{{ fallbackIcon }}</mat-icon>
}
